module.exports = __webpack_public_path__ + "img/simulated_free_bidding.562c40c7.png";